'use strict';

const ajax = require('./modules/ajax'),
    ajaxUrl = require('./modules/util/ajaxUrl'),
    bonusProductsView = require('./bonus-products-view');

const setAddToCartHandler = function (e) {
    e.preventDefault();
    const form = $(this).closest('form');

    const options = {
        url: ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };
    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {lineItemId: response.result.lineItemId},
                callback: function (response) {
                    bonusProductsView.show({url: $($.parseHTML(response)).find('#js-minicart-bonus-product-url').data('bonusproducturl'), giftChange: false, response: response, isAddedPopup: $($.parseHTML(response)).find('#js-minicart-bonus-product-url').data('showadded')});
                    form.find('input,textarea').val('');
                }
            });
        } else {
            form.find('span.error').hide();
            for (const id in response.errors.FormErrors) {
                let $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
                if (!$errorEl || $errorEl.length === 0) {
                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
                    $('#' + id).after($errorEl);
                }
                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
            }
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            console.info(Resources.BAD_RESPONSE);
        } else {
            console.info(Resources.SERVER_CONNECTION_ERROR);
        }
    });
};

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);
};
